import React from 'react';

// Components
import { RaindropsTable } from './RaindropsTable';

export const RaindropsList: React.FC = () => {
  return (
    <>
      <RaindropsTable />
    </>
  );
};
